import { Injectable } from '@angular/core';
import { SingletonServiceGuard } from '@lsq-frontend/angular-shared/features/generic-get-services';
import { DeviceDetectorService } from 'ngx-device-detector';

@Injectable({ providedIn: 'root' })
export class DetectBrowserService {
    constructor(private deviceDetectorService: DeviceDetectorService) {
        SingletonServiceGuard.register('DetectBrowserService');
    }

    public isIE(version?: number): boolean {
        if (this.deviceDetectorService.browser.toLowerCase() === 'ie') {
            if (version) {
                return this.deviceDetectorService.browser_version.startsWith(`${version}`);
            }
            return true;
        }
        return false;
    }

    public isEdge(): boolean {
        return this.deviceDetectorService.browser.toLowerCase() === 'ms-edge';
    }

    public browserPrematurelyDirtiesInputs(): boolean {
        return this.isIE();
    }

    public isUnsupportedBrowser(): boolean {
        // Angular only supports IE 9 and above
        return this.isIE(9) || this.isIE(10);
    }

    public isPartiallySupportedBrowser(): boolean {
        return this.isIE(11) || this.isEdge();
    }
}
